import React, { useRef, useState } from 'react';
import "./App.css";
import Header from './components/Header';
import HeroSection from './components/HeroSection';
import PromoImagesSection from './components/PromoImagesSection';
import ServicesSection from './components/ServicesSection';
import TestimonialsSection from './components/TestimonialsSection';
import Footer from './components/Footer';

function App() {
  const servicesRef = useRef(null);
  const contactRef = useRef(null);

  const scrollToServices = () => {
    servicesRef.current?.scrollIntoView({ behavior: 'smooth' });
  };

  const scrollToContact = () => {
    contactRef.current?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <div className="App min-h-screen bg-[#f5f3ef]">
      <Header 
        onScrollToServices={scrollToServices} 
        onOpenBooking={scrollToContact}
      />
      <HeroSection 
        onScrollToServices={scrollToServices}
        onOpenBooking={scrollToContact}
      />
      <PromoImagesSection />
      <ServicesSection ref={servicesRef} />
      <TestimonialsSection />
      <Footer ref={contactRef} />
    </div>
  );
}

export default App;
